import React from 'react'
import { useTranslation } from 'react-i18next';
import { ButtonHLPure, HeaderHLPure, SimpleLoading } from '../../pures';
import { Container, Grid } from '@material-ui/core';
import styles from './survey-answers.module.css'
import ScaleAnswers from '../../pures/survey-answers/scale-answers';
import TextAnswers from '../../pures/survey-answers/text-answers';
import NumericAnswers from '../../pures/survey-answers/numeric-answers';
import DropdownAnswers from '../../pures/survey-answers/dropdown-answers';
import CheckboxAnswers from '../../pures/survey-answers/checkbox-answers';
import DateAnswers from '../../pures/survey-answers/date-answers';
import { useHistory } from 'react-router-dom';

const SurveyAnswersView = (props) => {
    const { isLoading, data, downloadCSV } = props;
    const { t } = useTranslation('survey', { keyPrefix: 'surveyAnswers' });
    const history = useHistory()

    if (isLoading) {
        return <div className="loading">
            <SimpleLoading />
        </div>
    }

    const { stats, questions } = data;
    const engagement = stats.requests ? (stats.answers / stats.requests * 100).toFixed(2) : "0.00"

    return (
        <Container className="view-container surveyAnswersView">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <HeaderHLPure title={`${t("title")} - ${data.title}`} />
                </Grid>
                <Grid item xs={12}>
                    <Container maxWidth={"md"}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} className="button-actions">
                                <ButtonHLPure
                                    colorScheme={"text"}
                                    onClick={downloadCSV}
                                    nameBtn={<p><span class="k-icon k-font-icon k-i-download"></span> Download all answers</p>}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className='dashboardView-card'>
                                    <p className={styles.statistic}>{t("numberAnswers")}:<br /><span>{stats.answers}</span></p>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className='dashboardView-card'>
                                    <p className={styles.statistic}>{t("engagement")}:<br /><span>{engagement}%</span></p>
                                </div>
                            </Grid>

                            {
                                questions.map((question) => {
                                    switch (question.typeQuestion) {
                                        case 'text':
                                            return <Grid item key={question.id} xs={12}>
                                                <TextAnswers t={t} question={question} />
                                            </Grid>

                                        case 'numeric':
                                            return <Grid item key={question.id} xs={12}>
                                                <NumericAnswers t={t} question={question} />
                                            </Grid>

                                        case 'dropdown':
                                            return <Grid item key={question.id} xs={12}>
                                                <DropdownAnswers t={t} question={question} totalAnswers={stats.answers} />
                                            </Grid>

                                        case 'checkbox':
                                            return <Grid item key={question.id} xs={12}>
                                                <CheckboxAnswers t={t} question={question} totalAnswers={stats.answers} />
                                            </Grid>

                                        case 'datepicker':
                                            return <Grid item key={question.id} xs={12}>
                                                <DateAnswers t={t} question={question} />
                                            </Grid>

                                        case 'score':
                                            return <Grid item key={question.id} xs={12}>
                                                <ScaleAnswers t={t} question={question} />
                                            </Grid>

                                        default:
                                            return null
                                    }
                                })
                            }

                            <Grid item xs={12} className="button-actions">
                                <ButtonHLPure
                                    primary outlined
                                    nameBtn={t("returnButton")}
                                    onClick={() => history.goBack()}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>
            </Grid >
        </Container >

    )
}

export default SurveyAnswersView